<template>
    <button @click.prevent="add" :disabled="disabled">
        <slot></slot>
    </button>
</template>

<script>
export default {
    name: 'add-to-cart',
    components: {},
    data() {
        let self = this;

        return {
            disabled: true,
        };
    },
    props: {
        productSlug: {
            type: String,
            required: true,
        }
    },
    computed: {},
    methods: {
        add() {
            if (this.$root.cart) {
                this.$root.cart.add(this.productSlug);
            }
        }
    },
    mounted() {
        this.disabled = false;
    }
}
</script>
